import React, {useState, useCallback} from 'react';
import { Text, Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import Colors from 'components/Colors.js';
const colors = new Colors();
const RED = '#eb3434';
const YELLOW = '#ebe534';

export default function DrawnLine(props) {
    let [isHovered, setIsHovered] = useState(false);
    let {line} = props;
    let color = isHovered || props.isSelected ?
        YELLOW :
        RED;
    color = colors.brighten(color, line.brightness || 1);
        

    const onClickLine = useCallback((e) => {
        e.cancelBubble = true;
        props.onClickLine();
    }, [props.onClickLine]);

    const onClickPoint = useCallback((e, x, y) => {
        e.cancelBubble = true;
        props.onClickPoint(x, y);
    }, [props.onClickPoint]);

    return (
        <Group>
          <Line
            onMouseLeave={() => setIsHovered(false)}
            onMouseOver={() => setIsHovered(true)}
            onMouseDown={onClickLine}
            strokeWidth={10} alpha={0.1} stroke="black" points={[line.x1, line.y1, line.x2, line.y2]}/>
          <Line
            onMouseDown={onClickLine}
            strokeWidth={2} stroke={color} points={[line.x1, line.y1, line.x2, line.y2]}/>

          <Circle
            onMouseDown={(e) => onClickPoint(e, line.x1, line.y1)}
            x={line.x1} y={line.y1} radius={8} fill="black"/>
          <Circle x={line.x1} y={line.y1} radius={2} fill="red"/>
          <Circle
            onMouseDown={(e) => onClickPoint(e, line.x2, line.y2)}
            x={line.x2} y={line.y2} radius={8} fill="black"/>
          <Circle x={line.x2} y={line.y2} radius={2} fill="red"/>
        </Group>
    );
}
